import $ from 'jquery';

let counter = 0;

const getIcon = type => {
    switch (type) {
        case 'success':
            return '<i class="fa-solid fa-check"></i>';
        case 'notice':
            return '<i class="fa-solid fa-question"></i>';
        case 'warning':
            return '<i class="fa-solid fa-circle-exclamation"></i>';
        case 'error':
            return '<i class="fa-sharp fa-solid fa-circle-xmark"></i>';
    }
};

const $wrapper = $('#notifications');

export const removeNotification = id => {
    const $notification = $wrapper.find('#ntf' + id);
    if ($notification.length === 0) {
        return;
    }
    $notification.removeClass('show');
    setTimeout(() => {
        $notification.remove();
    }, 500);
};

export const addNotification = (message, type = 'success', sticky = false) => {
    const icon = getIcon(type);
    const id = counter++;
    const $notification = $(`
        <div id="ntf${id}" class="notification notification--${type}">
            <div class="notification__wrapper">
                <span class="notification__close"><i class="fa-regular fa-circle-xmark"></i></span>
                <div class="notification__icon">
                    <span>${icon}</span>
                </div>
                <div class="notification__message">
                    <p>${message}</p>
                </div>
            </div>
        </div>
    `);

    $notification.appendTo($wrapper);
    $notification.find('.notification__close').on('click', () => {
        removeNotification(id);
    });
    setTimeout(() => {
        $notification.addClass('show');
    }, 1);

    if (!sticky) {
        setTimeout(() => {
            removeNotification(id);
        }, 5000);
    }

    return id;
};
